// @givmo/app-charity — `/org`: the Admin Console's APPS page (CPA-WEB40 · shell contract v3).
//
// ══ WHAT THIS PAGE IS ══════════════════════════════════════════════════════════════════════════
//
// The Admin Console's landing. Every app this organization is offered, each with the switch that
// decides whether the organization has it at all — the Donations card ALWAYS ON with NO switch
// (`switchable: false` off the settings read, D-CP-43) — the count of people who can open it (a
// door to the roster narrowed to that app), the terms modal before Turn On for an app whose class
// binds one, and — above the cards — the one-line pending-requests strip. That is the whole page.
// (The ⋯ entry that carried "Who can approve requests for this app" went with that setting:
// EP-WEB36, D-EP-58.)
//
// ⚠ ACTIVITY IS NOT HERE ANY MORE: the record is its own page (`/org/activity`).
//
// ⚠ THIS PAGE ALSO ANSWERS `/apps` FOR A HOLDER OF `write_settings` (D3/D6): the full-page app grid
// FOLDED into it — `/org` canonical, `/apps` a replace-redirect here — so the `home-module-grid`
// contract id survives on THIS page and nowhere else.
//
// ⚠ THE SWITCHES ARE THE PACKAGE'S, KEYED ON `org_ref`, and this page supplies only the words and the
// routes (`use-org-console-config.ts`). The company console mounts the same panel.
//
// ⚠ THE GATE IS THE PAGE'S OWN CAPABILITY, `write_settings` (`require-capability.tsx`), wrapped at
// the route — never a tier. The enrollment door (CBO-IN3) was NOT re-homed here (ruling 2026-09-02).
//
// DATA CONTRACT: `page-org` is the route's root; `home-module-grid` wraps the management grid;
// everything inside is the package's `org-console-modules-*` family.

import { OrgModulesPanel } from '@givmo/org-console';
import { useBooksActivation } from '../books/use-books-activation';
import { testIdProp } from '@givmo/design-system';
import { PageShell } from '../../components/page-shell';
import { useOrgConsoleConfig } from '../org-console/use-org-console-config';

const PREFIX = 'org';
const TITLE = 'Apps';

export function OrgPage() {
  const config = useOrgConsoleConfig();
  const startProvisioning = useBooksActivation(config?.orgRef ?? null);

  return (
    // No description: the sidebar already names whose apps these are, and the one sentence worth
    // reading here — what turning an app off actually does — belongs to the control that does it.
    <PageShell testId="page-org" title={TITLE}>
      {config === null ? (
        <p className="font-sans text-s13 text-text-tertiary" {...testIdProp(`${PREFIX}-pending`)}>
          Loading…
        </p>
      ) : (
        <div {...testIdProp('home-module-grid')}>
          <OrgModulesPanel config={config} onStartProvisioning={startProvisioning} />
        </div>
      )}
    </PageShell>
  );
}
